module.exports = __webpack_public_path__ + "img/stock1.10dfbecb.png";